import styled from "styled-components"

interface TextAreaStyles {
  marginBottom: number
}

interface TextAreaProps {
  title?: string,
  placeholder?: string,
  errorMessage?: string,
  value?: string
  onChange?: (text: string) => void
  styles?: TextAreaStyles
  onEnter?: () => void
}

export default function TextAreaView({
  title,
  placeholder,
  errorMessage,
  value,
  onChange,
  onEnter,
  styles = { marginBottom: 0 },
}: TextAreaProps) {
  return (
    <TextAreaViewDiv
      {...styles}
      enableError={errorMessage !== undefined && errorMessage !== ''}
      className="text_field_view">
      {title && (
        <p className="form_label">{title}</p>
      )}
      <textarea
        placeholder={placeholder}
        value={value}
        onChange={e => {
          if(onChange) onChange(e.target.value)
        }}
        onKeyDown={e => {
          if(e.key === 'Enter') {
            if(onEnter !== undefined) {
              onEnter()
            }
          }
        }}
        className="outlined_gray"
      />
      {errorMessage !== undefined && <p className="error_msg fs12">{errorMessage}</p>}
    </TextAreaViewDiv>
  )
}

interface StyledProps extends TextAreaStyles {
  enableError: boolean
}

const TextAreaViewDiv = styled.div<StyledProps>`
  margin-bottom: ${props => props.enableError ? props.marginBottom - 18 : props.marginBottom}px;
  position: relative;
  
  textarea{
    width: 100%;
    height: 200px;
  }
  .error_msg{
    color: #ea4335;
    line-height: 14px;
    margin-top: 4px;
  }
`